import React , { Component } from 'react';
import {Input } from 'reactstrap';

export default class DropDown extends Component {
    render() {
      return (
        <Input type="select" name={this.props.name} id={this.props.id} readOnly={this.props.readOnly} disabled={this.props.disabled} onChange={this.props.onChange}  defaultValue={this.props.value} className={this.props.className}>
            {this.props.first_element && <option value="undefined">{this.props.first_element}</option>}
            {this.props.data.map(x =>
            <option key={x.id} value={x.id}>{x.name}</option>)}
          </Input>
      )
    }
  }
  


// WEBPACK FOOTER //
// ./src/shared/components/DropDown/index.js